import { useTimeout } from '@pogokid/react-hooks'
import {
  Box,
  Fade,
  Typography,
  CircularProgress,
} from '@pogokid/mui'
import { Logo } from '~m/AppUi/components/Logo.tsx'
import { ReactNode, useEffect } from 'react'
import { captureException } from '@sentry/react'

interface AppLoadingOrErrorProps {
  message?: ReactNode
  error?: Error | null
}

export function AppLoadingOrError({
  message,
  error,
}: AppLoadingOrErrorProps) {
  useEffect(() => {
    if (error) {
      captureException(error)
    }
  }, [error])

  const [fadeInLogo] = useTimeout(500)
  const [fadeInProgress] = useTimeout(3000)

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      padding={1}
      gap={2}
      textAlign="center"
    >
      <Fade in={!!fadeInLogo()} timeout={3000}>
        <Box data-testid="LoadingOrError">
          {error ? error.message : <Logo />}
          {message && (
            <Typography component="p" variant="caption">
              {message}
            </Typography>
          )}
        </Box>
      </Fade>
      <Fade in={!!fadeInProgress()} timeout={3000}>
        <CircularProgress size={20} variant="indeterminate" />
      </Fade>
    </Box>
  )
}
